<template>
  <div class="text-center">
    <pulse-loader
      :loading="loading"
      :color="loadingColor"
      style="text-align: center"
    />
  </div>
</template>

<script>
export default {
  props: ["loading"],
  data() {
    return {
      loadingColor: this.$root.$constants.LOADING_COLOR
    };
  }
};
</script>
